import React, { createContext, useLayoutEffect, useRef, useState } from 'react';
import { getInitialHomeProduct, homeProducts } from '../utils/home-preferences';

export const HomeProductContext = createContext<{
    activeIndex: number;
    setActiveIndex: React.Dispatch<React.SetStateAction<number>>;
    resetProduct: () => void;
} | null>(null);

// Mounted around Gatsby pages only for the BitTorrent brand. Manual choices
// live for this document; refreshing any page starts a new selection lifetime.
export function HomeProductProvider({ children }: { children: React.ReactNode }) {
    const [activeIndex, setActiveIndex] = useState(0);
    const defaultIndex = useRef(0);

    useLayoutEffect(() => {
        defaultIndex.current = homeProducts.indexOf(getInitialHomeProduct(window));
        setActiveIndex(defaultIndex.current);
    }, []);

    return (
        <HomeProductContext.Provider value={{
            activeIndex,
            setActiveIndex,
            resetProduct: () => setActiveIndex(defaultIndex.current),
        }}>
            {children}
        </HomeProductContext.Provider>
    );
}
